import { map } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { Transition } from '@uirouter/angular';

import { FormatDatePipe } from '../../../_shared/format-date.pipe';
import { TrainersLabelPipe } from '../../../_shared/trainers-label.pipe';
import { LabelSkillComponent } from '../../../_shared/label/label.component';

import {
    SessionStaffing,
    SessionStaffingService,
    Trainer,
    TrainerService,
} from '../../../../_services';

@Component({
    selector: 'virtual-session-detail',
    templateUrl: 'detail.component.html',
    styleUrls: [
        '../../detail/detail.component.scss',
        '../../../_shared/label/label.component.scss',
    ],
    providers: [
        TrainersLabelPipe,
        FormatDatePipe,
        LabelSkillComponent,
        TranslatePipe,
    ],
})
export class SessionStaffingDetailComponent implements OnInit {
    virtualSession: SessionStaffing;
    trainers: Trainer[] = [];
    trainersResponses: any = [];
    selectedTrainers: any = {};
    error: string;
    success: boolean;

    constructor(
        private sessionStaffingService: SessionStaffingService,
        private trainerService: TrainerService,
        private trans: Transition
    ) {}

    ngOnInit() {
        let virtualSessionId = this.trans.params()['id'];
        this.sessionStaffingService
            .findOneVirtualSession(virtualSessionId)
            .subscribe((virtualSession) => {
                this.virtualSession = virtualSession;
            });

        this.trainerService.findAll().subscribe((trainers) => {
            this.selectedTrainers = {};
            this.trainers = trainers
                .filter((trainer) => {
                    return trainer.email && trainer.email.length > 0;
                })
                .map((trainer) => {
                    this.selectedTrainers[trainer.id] = {
                        trainer: trainer,
                        selected: false,
                    };
                    let trainerSkills = trainer.trainerSkills.map((skill) => {
                        skill.highLight = true;
                        return skill;
                    });
                    return new Trainer(
                        trainer.id,
                        trainer.firstName,
                        trainer.lastName,
                        '',
                        trainer.companyName,
                        trainer.email,
                        trainer.active,
                        trainerSkills,
                        trainer.bio
                    );
                });

            this.sessionStaffingService
                .getTrainersResponses(virtualSessionId)
                .subscribe((responses) => {
                    this.trainersResponses = responses;
                });
        });
    }

    save() {
        this.sessionStaffingService.edit(this.virtualSession).subscribe(
            () => {
                this.error = null;
                this.success = true;
            },
            () => {
                this.success = false;
                this.error = 'ERROR';
            }
        );
    }

    sendMail() {
        return (sessionId, trainerIds) => {
            return this.sessionStaffingService
                .proposeVirtualSessionToTrainers(sessionId, trainerIds)
                .pipe(
                    map((_) => {
                        this.sessionStaffingService
                            .getTrainersResponses(sessionId)
                            .subscribe((responses) => {
                                this.trainersResponses.length = 0;
                                this.trainersResponses.push(...responses);
                                return _;
                            });
                    })
                );
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/staffing/detail/detail.component.ts